//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { PortalType } from './Enums';

export class WebsiteBlockLoginFormUserDisplayItem extends ItemBase {
    SchoolName: string | null = null;
    FirstName: string | null = null;
    PortalType: PortalType = PortalType.StudentPortal;

    constructor(initializer?: Partial<WebsiteBlockLoginFormUserDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "WebsiteBlockLoginFormUserDisplayItem";
}
